// Mobile dashboard — delegates to DashboardHome, which stacks the
// four zones into one column at phone width via auto-fit grids. The
// previous mobile-specific stack-of-cards layout (CelebrationStrip,
// CountdownHero, QuickRsvpList, RecentResultsCard, WeatherTravelCard,
// TeamChemistryCard, ActivityFeed, MyCricketStatsMobile, SplitsRollup,
// CricketCareerCard, Latest announcements) has been consolidated into
// DashboardHome so desktop and mobile stay in lockstep.

import React from "react";
import DashboardHome from "../components/DashboardHome";

export default function DashboardMobile(props) {
  return <DashboardHome {...props}/>;
}
